<!-- 
程式：webContent.vue
功能：活動內容
作者：i9400540 施義濃
完成：2020-02-15
-->
<template>
  <div class="content_font">
    <div class="l-container">
      <div class="o-menuMask"></div>
      <div v-html="htmlContent"></div>
      <a href="javascript:;" class="o-gotoTop" data-id="gotop"></a>
    </div>
    <div id="CI_LINK_MSG" class="mfp-hide" style="width: 30%;margin: 0 auto;">
      <div class="c-popup__head" data-alert="title">提醒您</div>
      <div class="c-popup__content u-align-center">
        <div data-alert="content">您將離開本頁面，並前往國泰人壽官網首頁。</div>
        <div class="c-popup__actions">
          <a
            href="javascript:;"
            class="o-btn o-btn--normal"
            style="margin-right:5px"
            data-mfp-close
          >取消</a>
          <a
            @click="gotoCathayLife"
            class="o-btn o-btn--normal o-btn--primary"
            style="margin-left:5px"
          >立即前往</a>
        </div>
      </div>
    </div>
     <!-- 回國泰人壽官網首頁 -->
    <div id="CI_LINK_MSG2" class="c-popup c-popup--alert">
      <div class="c-popup__head" data-alert="title">提醒</div>
      <div class="c-popup__content u-align-center">
        <div
          data-alert="content"
          style="text-align: left;"
        >很抱歉！本活動限國泰人壽在職內外勤員工(除業專、服中客服專員)，您將離開本頁面，並前往網路投保網站。</div>
        <div class="c-popup__actions">
          <a @click="gotoCathayLife" class="o-btn o-btn--normal o-btn--primary">立即前往</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DTODAV02 from "@/service/DTODAV02.js";
import DTODAVZ1 from "@/service/DTODAVZ1.js";
import $ from "jquery";
import "magnific-popup/dist/magnific-popup.css";
import "magnific-popup";

export default {
  name: "webContent",
  mounted() {
    const metaData = this.$route.params.data || "";
    if (metaData) {
      const head = document.querySelector("head");
      const gtmScriptStr = this.$route.params.data.scriptStr;
      if (gtmScriptStr) {
        const gtmScriptArr = gtmScriptStr.split("~");
        gtmScriptArr.forEach((gtmScript) => {
          const script = document.createElement("script");
          let text = document.createTextNode(gtmScript);
          script.appendChild(text);
          head.append(script);
        });
      }
      const body = document.querySelector("body");
      const gtmNoScriptStr = this.$route.params.data.noScriptStr;
      if (gtmNoScriptStr) {
        const gtmNoScriptArr = gtmNoScriptStr.split("~");
        gtmNoScriptArr.forEach((gtmNoScript) => {
          const noscript = document.createElement("noscript");
          let text = document.createTextNode(gtmNoScript);
          noscript.appendChild(text);
          body.append(noscript);
        });
      }
    }
  },
  data() {
    return {
      actInfo: {
        act_id: "",
        login_e: "",
        login_m: "",
        page_id: "",
        home_page: ""
      },
      htmlContent: "",
      isLogin: false,
      msg: "請先登入",
      //國泰人壽首頁
      VUE_APP_LINK_CATHAYLIFE: process.env.VUE_APP_LINK_CATHAYLIFE,
      //網路投保首頁
      VUE_APP_LINK_WTHOME: process.env.VUE_APP_LINK_WTHOME,
      //會員專區
      VUE_APP_LINK_MEMBER: process.env.VUE_APP_LINK_MEMBER,
      //聯絡我們
      VUE_APP_LINK_CONNECTION: process.env.VUE_APP_LINK_CONNECTION,
      //顧客資料保密措施
      VUE_APP_LINK_SECRET: process.env.VUE_APP_LINK_SECRET
    };
  },
  created() {
    import("@/assets/webpage/js/vendor/modernizr-3_5_0-min.js").then(m => {});

    import("@/assets/webpage/js/vendor/picturefill/picturefill-min.js").then(
      m => {}
    );
    import("@/assets/webpage/js/vendor/picturefill/pf-mutation-min.js").then(
      m => {}
    );
    import("@/assets/webpage/js/vendor/matchMedia/matchMedia-min.js").then(
      m => {}
    );
    import("@/assets/webpage/js/vendor/jquery-fancyform/jquery-fancyform-min.js").then(
      m => {}
    );
    import("@/assets/webpage/js/vendor/slick/slick.js").then(m => {});

    this.actInfo = this.$route.params.data || "";
    //bind 錨點的方法
    window.scrollAnchor = this.scrollAnchor.bind(this);


    const cVue = this;
    const temp = this.$route.params.data || "";
    if (temp) {
      if (temp.login_e == "Y") {
        // 員工登入的活動資格檢核
        cVue.getQual(temp);
      } else if (temp.login_e == "N") {
        cVue.doQuery(temp.act_id);
      }
    } else {
      // 非 ODAVF000 進來 → 踢回 F000
      window.location.href =
        window.location.protocol + "//" + window.location.host + "/ODAV/action/" + this.$route.query.id;
    }
  },
  metaInfo () {
    let metaData = this.$route.params.data || {};
    let imgUrl =  metaData.img_src ? window.location.protocol +"//"+window.location.host + "/ODAV/Path/" + metaData.img_src : "";
    return {
      title: metaData.act_nm || "國泰人壽",
      meta: [
        {
          name: "keyWords",
          content: metaData.act_kws || ""
        },
        {
          name: "description",
          content: metaData.act_des || ""
        },
        {
          name: "image",
          content: imgUrl
        },
        {
          name: "scriptStr",
          content: metaData.scriptStr || ""
        },
        {
          name: "noScriptStr",
          content: metaData.noScriptStr || ""
        },
        {
          property: "og:title",
          content: metaData.act_nm || ""
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          property: "og:description",
          content: metaData.act_des || ""
        },
        {
          property: "og:url",
          content: metaData.act_id ? window.location.protocol +"//"+window.location.host + "/ODAV/action/" + metaData.act_id : ""
        },
        {
          property: "og:image",
          content: imgUrl
        },
        {
          property: "og:scriptStr",
          content: metaData.scriptStr || ""
        },
        {
          property: "og:noScriptStr",
          content: metaData.noScriptStr || ""
        },
        {
          property: "og:image:width",
          content: "1200"
        },
        {
          property: "og:image:height",
          content: "630"
        }
      ]
    };
  },
  methods: {
    // 取得活動資格
    getQual(temp) {
      this.$cathayAxios.post(DTODAVZ1.getQual, {act_id: temp.act_id}).then(resp => {
        if (resp.returnCode == 0) {
          let is_chk = resp.data || false;
          if (is_chk) {
            this.doQuery(temp.act_id);
          } else {
            this.showAlert(temp);
          }
        } else {
          this.showAlert(temp);
        }
      });
    },
    // 取得編輯資料
    doQuery(act_id) {
      let cVue = this;
      let tempContent = "";
      cVue.$cathayAxios
        .post(DTODAV02.getActContent, {
          act_id: act_id
        })
        .then(resp => {
          if (resp.returnCode == 0) {
            let data = resp.data || [];
            for (let i = 0; i < data.length; i++) {
              let html = decodeURIComponent(data[i].block_content);
              const div = document.createElement("div");
              div.innerHTML = html;

              // 調整 Logo
              const logo = div.querySelector(".o-logo");
              if (logo) {
                logo.style.height = "32px";
                logo.style.width = "auto";
                logo.style.verticalAlign = "middle";
              }

              // 調整「網路投保」間距
              const link = div.querySelector(".l-header__logo a:last-child");
              if (link) {
                link.style.marginLeft = "32px";
              }

              tempContent += div.innerHTML;
            }
            if (tempContent) {
              cVue.htmlContent = tempContent;
              cVue.$nextTick(() => {
                // 圖片載入
                cVue.initFun();
              });
            }
          }
        });
    },
    // 前往國泰人壽
    gotoCathayLife(temp) {
      if (!temp || !temp.home_page) {
          window.location.href = this.VUE_APP_LINK_CATHAYLIFE;
      } else {
        window.location.href = temp.home_page;
      }
    },
    // 錨點
    scrollAnchor(id) {
      let animationTime = {
        type: Number,
        default: 300
      };
      let item = $("#" + id);
      if (!item || item.length == 0) {
        return;
      }
      let move = item.offset().top - 65;
      $("html").animate({ scrollTop: move }, this.animationTime);
    },
    // 回國泰人壽網頁
    showAlert(temp) {
      $.magnificPopup.open({
        items: { src: "#CI_LINK_MSG2", type: "inline" },
        closeOnBgClick: false,
        enableEscapeKey: false
      });

      const cVue = this;
      setTimeout(function() {
        cVue.gotoCathayLife(temp);
      }, 3000);
    },

    initFun() {
      $("#CI_Link").on("click", function (e) {
        e.preventDefault();
        $.magnificPopup.open({
          items: {
            src: "#CI_LINK_MSG",
            type: "inline",
          },
          callbacks: {
            open: function () {
              $("#CI_LINK_MSG_Link1").on("click", function (e) {
                e.preventDefault();
                window.location = VUE_APP_LINK_CATHAYLIFE;
              });

              $("#CI_LINK_MSG .o-btn--normal[data-mfp-close]").on(
                "click",
                function (e) {
                  e.preventDefault();
                  $.magnificPopup.close();
                }
              );
            },
          },
        });
      });
    },
  }
};
</script>
<style src="@/assets/webpage/css/jquery_fancyform/jquery_fancyform_min.css" >
</style>
<style src="@/assets/webpage/js/vendor/slick/slick-min.css" >
</style>
<style src="@/assets/webpage/js/vendor/slick/slick-theme-min.css" >
</style>
<style src="@/assets/webpage/js/vendor/bootstrap-datepicker/bootstrap-datepicker.standalone.min.css" >
</style>
<style src="@/assets/webpage/css/common/normalize-min.css" >
</style>
<style src="@/assets/webpage/css/common/animate-min.css" >
</style>
<style src="@/assets/webpage/css/common/layout-min.css" >
</style>
<style src="@/assets/webpage/css/form-min.css" >
</style>
<style src="@/assets/webpage/css/product-min.css" >
</style>
<style src="@/assets/webpage/css/index.css" >
</style>
<style src="@/assets/webpage/css/common/main.css" >
</style>
<style src="@/assets/third-party/css/font-awesome.min.css">
</style>
<style scoped>
.c-popup__content {
  background-color: white;
}
</style>